import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import {addForumTopicFollow, removeForumTopicFollow, resetForumTopicFollow} from "../../../creators/forum.topic.follow";

import {Button} from "../Button";
import CtaCannot from "../CtaCannot";
import {Can} from "../../../ability-context";

class TopicFollows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFollow: this.props.isFollow || false,
        };
        this.handleFollow = this.handleFollow.bind(this);
    }

    componentWillUnmount() {
        this.props.resetForumTopicFollow();
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.topicFollowError.error !== this.props.topicFollowError.error) && this.props.topicFollowError.error !== null) {
            this.setState({isFollow: !this.state.isFollow});
        }
        if (prevProps.isFollow !== this.props.isFollow) {
            this.setState({isFollow: this.props.isFollow});
        }
    }

    handleFollow() {
        if (this.state.isFollow) {
            this.props.removeForumTopicFollow(this.props.forumId, this.props.topicId);
            this.setState({isFollow: false});
        } else {
            this.props.addForumTopicFollow(this.props.forumId, this.props.topicId);
            this.setState({isFollow: true});
        }
    }

    render() {
        return (
            <Can action="follow" subject="Topic" passThrough>
                {can => {
                    return can ? (
                        <Button onClick={() => this.handleFollow()}
                                className={this.props.className || ""}
                                btnStyle={this.state.isFollow ? "primary-reverse" : "primary"}
                                size={"small"}
                                loading={this.props.topicFollowSubmitting}
                                content={this.state.isFollow ? "Ne plus suivre" : "Suivre"}/>
                    ) : (
                        <CtaCannot action={"addFollow"} isModal={true} button={{content : this.state.isFollow ? "Ne plus suivre" : "Suivre", btnStyle :this.state.isFollow ? "primary-reverse" : "primary", className : this.props.className || "", loading : this.props.topicFollowSubmitting }} />
                    )}}
            </Can>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        topicFollowError: state.forumTopicFollow.error,
        topicFollowLoading: state.forumTopicFollow.loading,
        topicFollowSubmitting: state.forumTopicFollow.submitting,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    addForumTopicFollow,
    removeForumTopicFollow,
    resetForumTopicFollow
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TopicFollows);